import { render, staticRenderFns } from "./ArticleListItem.vue?vue&type=template&id=484467a8&scoped=true&"
import script from "./ArticleListItem.vue?vue&type=script&lang=js&"
export * from "./ArticleListItem.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListItem.vue?vue&type=style&index=0&id=484467a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484467a8",
  null
  
)

export default component.exports